<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        :root="rootNode" 
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="input-block grid-col-1-3 grid-row-2-3">
        <label>
          Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.CHECKBOX_LABEL"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.content"
          name="content"
          required
          @blur="generateFieldName()"
        />
      </div>
      <div class="input-block grid-row-2-3">
        <label>
          Hint
          <tooltip :text="TOOLTIP_TEXT.HINT"></tooltip>
        </label>
        <input type="text" v-model="formData.hint" name="hint" />
      </div>
      <div style="visibility: none"></div>
      <div class="checkbox-block grid-column-1-4 grid-row-3-4">
        <input
          type="checkbox"
          name="required"
          id="metadata-checkbox-1"
          v-model="formData.required"
          @change="checkboxOnChange($event)"
          class="checkbox-input"
        />
        <label for="metadata-checkbox-1">
          Required
          <tooltip :text="TOOLTIP_TEXT.REQUIRED"></tooltip>
        </label>
      </div>
      <div class="input-block grid-col-1-2 grid-row-4-5">
        <label>
          Field Name (auto-populated)
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.FIELD_NAME"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.fieldName"
          name="fieldName"
          required
          disabled
        />
      </div>
      <div class="grid-col-1-4 grid-row-5-6">
        <slot></slot>
      </div>
      <fieldset v-if="!simpleView" class="more-option grid-col-1-4 grid-row-6-7">
        <legend>
          More Options
        </legend>
      </fieldset>
      <dependency-editor
        v-if="!simpleView"
        class="grid-col-1-3 grid-row-7-8"
        :dependency="getDependency()"
        :fieldName="this.formData.fieldName"
        @addDependency="addDependency($event)"
        @removeDependency="removeDependency($event)"
      ></dependency-editor>
    </div>
  </div>
</template>

<script>
import { ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { populateFieldName } from "../mixins/component-utils-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";
import DependencyEditor from "./DependencyEditor.vue";
import { Bus } from "../main";

export default {
  name: "CheckboxModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: ROOT_NODE.FIELDS,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
      populateFieldName: populateFieldName,
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("metadataSaved", this.formData);
        } else {
          this.formData = structuredClone(this.metadata);
        }
      }
    },
    simpleView: function() {
      this.insertIntoComponentModal();
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
    "dependency-editor": DependencyEditor,
  },
  mounted() {
    this.insertIntoComponentModal();

    Bus.$on("sendDupFieldName", (list) => this.checkDupFieldName(list));
  },
  beforeDestroy() {
    Bus.$off("sendDupFieldName");
  },
  methods: {
    getDependency: function () {
      if (this.formData.dependency) {
        return this.formData.dependency;
      }
      return { parent: "", displayIfValues: [] };
    },
    addDependency: function (obj) {
      if (!this.formData.dependency) {
        this.formData.dependency = { parent: "", displayIfValues: [] };
      }
      this.formData.dependency.parent = obj.parent;
      this.formData.dependency.displayIfValues = obj.displayIfValues;
    },
    checkboxOnChange: function (event) {
      this.formData[event.target.name] = event.target.checked;
    },
    removeDependency: function () {
      this.$delete(this.formData, "dependency");
    },
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
    insertIntoComponentModal: function () {
      const gridRow = "3 / 4";
      Bus.$emit("insertIntoComponentModal", this.$refs.body, gridRow);
    },
    // 1) Populate field name
    // 2) Emit event to FormEditor to check duplicate
    // 3) FormEditor send the list of duplicate field name using Bus
    // 4) If the list is not empty, adjust the field name
    generateFieldName: function () {
      const fieldName = populateFieldName(this.formData, 'content');
      if (fieldName) {
        Bus.$emit("getDupFieldName", fieldName);
      }
    },
    // If there is duplicate field name, append field name with counter
    checkDupFieldName: function (list) {
      const fieldName = this.formData.fieldName;
      if (list.length > 0) {
        let count = 1;
        let temp = fieldName ;
        while (list.find(name => name == temp)) {
          temp = fieldName + (count++);
        }
        count--;
        this.formData.fieldName = temp;
      }
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.checkbox-block {
  align-self: center;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 0 9px 3px 9px;
  margin-top: 3px;
  cursor: pointer;
  font-weight: bolder;
}

.checkbox-input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.grid-row-5-6 {
  grid-row: 5 / 6;
}

.grid-row-6-7 {
  grid-row: 6 / 7;
}

.grid-row-7-8 {
  grid-row: 7 / 8;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>